module.exports = __webpack_public_path__ + "static/media/kenji-bio.db543444.pdf";